import Component from './Component';
import * as particles from 'pixi-particles';
import GameObject from '../GameObject/GameObject';

export default class ParticlesComponent extends Component {
    public elapsedTime: number = 0;
    public emitter: particles.Emitter = undefined;
    public textures: string[] = [];
    public data: any = undefined;

    public onAttach(gameObject: GameObject, params: any) {
        this.emitter = new particles.Emitter(
            this.container,
            this.textures,
            this.data
        );
    }
    public onDetach() {
        this.emitter.destroy();
    }
}
